module.exports = __webpack_public_path__ + "img/issueNo.457fc522.png";